'use client'

/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useEffect } from 'react'
import dynamic from 'next/dynamic'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { segmentEvents } from '@configs/segmentEvents.config'
import Shimmer from '@components/Shimmer/Shimmer'

const TravelSemDesktopWidget = dynamic(() => import('./TravelSemDesktopWidget'), {
  ssr: false,
  loading: () => <Shimmer />,
})

const RenderWidgetMobile = dynamic(() => import('../../renderWidgetMobile'), {
  ssr: false,
})

const TravelMainSemWidget = ({
  isBottomFloater,
  segmentEventCommonProperties,
  isMobileDevice,
  isSemPage,
}: {
  isBottomFloater?: boolean
  segmentEventCommonProperties?: any
  isMobileDevice?: any
  isSemPage?: any
}) => {
  const commonProps = { isBottomFloater, isMobileDevice, segmentEventCommonProperties, isSemPage }

  const [properties, setProperties] = useState<any>(null)

  useEffect(() => {
    const widgetType = segmentEvents.sem.widgetType

    const fetchProperties = async () => {
      const props = await segmentEventCommonPropFunc(segmentEventCommonProperties)
      setProperties({ ...props, widget_type: widgetType, funnel: 'entry' })
    }

    fetchProperties()
  }, [])

  return (
    <>
      {isMobileDevice && !isBottomFloater && (
        <RenderWidgetMobile
          ctaText="View plans"
          source="sem"
          eventName="tap_btn_int_continue"
          properties={properties}
        />
      )}

      {(!isMobileDevice || isBottomFloater) && (
        <TravelSemDesktopWidget {...commonProps} eventName="tap_btn_int_continue" properties={properties} />
      )}
    </>
  )
}

export default TravelMainSemWidget
